import {FlashcardsModel} from './models';
import {FlashcardsState, FlashcardState} from './classroom/models';

function initialState(model: FlashcardsModel): FlashcardsState {
  const cards: FlashcardState[] = model.cards.map(x => ({flipped: false}));
  return {cards: cards};
}

class FlashcardsUtilsClass {
  readonly initialState = initialState;
}

export const flashcardsUtils = new FlashcardsUtilsClass();
